import { defineChannelContract } from 'shared/channels';
import type { ServiceWorkerConfigInput } from './serviceWorkerConfigModel';

/** Contract of the page and the worker for the worker's config. */
export const serviceWorkerConfigContract = defineChannelContract<{
  requests: {
    /** Resolves once the config is stored. */
    set: { request: ServiceWorkerConfigInput; response: void };
    /** The app language changed: the worker downloads the project data again. */
    changeLanguage: { request: undefined; response: void };
  };
  events: Record<never, never>;
}>('configChannel');
